import axios from "axios";

const { REACT_APP_TELEMATIC_API } = process.env;

export const getConnectorDeereStatus: any = (
  company: string
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  return axios({
    method: "get",
    url: `${REACT_APP_TELEMATIC_API}/connector/deere/status?customer=${company}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("axios error", error);
    });
};

export const getConnectorDeereStart: any = (
  company: string
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  return axios({
    method: "get",
    url: `${REACT_APP_TELEMATIC_API}/connector/deere/start?customer=${company}&noredirect=1`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("axios error", error);
    });
};

export const postConnectorDeereReset: any = (
  company: string
) => {
  const token = document.cookie
    .split("; ")
    .find((row) => row.startsWith("token"))
    ?.split("=")[1];
  return axios({
    method: "post",
    url: `${REACT_APP_TELEMATIC_API}/connector/deere/reset?customer=${company}`,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.error("axios error", error);
    });
};